function isLandingHomePage() {
  return !!(
    document.querySelector('script[src*="/assets/landing.js"]') ||
    document.querySelector('link[href*="/assets/landing.css"]')
  );
}

function clearLandingHeaderPollution() {
  document.documentElement.classList.remove("n22-new-header");
  if (document.body) document.body.classList.remove("n22-new-header-active");
  var bad = document.getElementById("22n-storefront-header-grid-v8");
  if (bad) bad.remove();
}

/* Landing only: strip stale ScriptTag pollution. Grid lives in CSS, not JS. */
(function () {
  if (isLandingHomePage()) clearLandingHeaderPollution();
})();

(function () {
  if (isLandingHomePage()) return;
  if (window.__N22_WISHLIST_STOREFRONT_V2__) return;
  window.__N22_WISHLIST_STOREFRONT_V2__ = true;

  var SHOP = (window.__22N_CONFIG__ && window.__22N_CONFIG__.shop) ||
    (window.Shopify && Shopify.shop
      ? ("https://" + (String(Shopify.shop).indexOf(".") >= 0 ? Shopify.shop : "22nationshop.com"))
      : "https://22nationshop.com");
  var WISHLIST_STORAGE_KEY = "22n_wishlist";
  var WISHLIST_COOKIE = "22n_wishlist";
  var WISHLIST_MAX_AGE = 60 * 60 * 24 * 365;
  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S5 16 3 10.5C1.5 6.5 4 4 7 4c2 0 3.5 1.2 5 3 1.5-1.8 3-3 5-3 3 0 5.5 2.5 4 6.5C19 16 12 20.5 12 20.5z"/></svg>';

  function shopProductUrl(handle) {
    return SHOP.replace(/\/$/, "") + "/collections/shop-all/products/" + handle;
  }

  function canonicalShopUrl(url) {
    if (!url) return SHOP;
    var trimmed = String(url).trim();
    var absolute = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : (trimmed.indexOf("//") === 0
        ? "https:" + trimmed
        : (SHOP.replace(/\/$/, "") + (trimmed.charAt(0) === "/" ? trimmed : "/" + trimmed)));
    try {
      var u = new URL(absolute);
      u.hash = "";
      var path = u.pathname.replace(/\/+$/, "") || "/";
      var productMatch = path.match(/\/products\/([^/]+)/i);
      if (productMatch) return shopProductUrl(productMatch[1]);
      return u.origin + path + u.search;
    } catch (e) {
      return absolute;
    }
  }

  function wishlistId(url) {
    var shopAllMatch = (url || "").match(/\/collections\/shop-all\/products\/([^/?#]+)/i);
    if (shopAllMatch) return shopAllMatch[1];
    var productMatch = (url || "").match(/\/products\/([^/?#]+)/i);
    if (productMatch) return productMatch[1];
    var collectionMatch = (url || "").match(/\/collections\/([^/?#]+)/i);
    if (collectionMatch) return "collection:" + collectionMatch[1];
    return url || "";
  }

  function readWishlist() {
    var items = [];
    try {
      var stored = localStorage.getItem(WISHLIST_STORAGE_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) items = parsed;
      }
    } catch (e) {}
    return items.map(function (item) {
      return Object.assign({}, item, { url: canonicalShopUrl(item.url), checked: !!item.checked });
    });
  }

  function writeWishlist(items) {
    var payload = JSON.stringify(items);
    try { localStorage.setItem(WISHLIST_STORAGE_KEY, payload); } catch (e) {}
    try {
      document.cookie = WISHLIST_COOKIE + "=" + encodeURIComponent(payload) +
        "; path=/; max-age=" + WISHLIST_MAX_AGE + "; SameSite=Lax";
    } catch (e) {}
  }

  function injectWishCss() {
    if (document.getElementById("n22-wishlist-storefront-css")) return;
    var css = document.createElement("style");
    css.id = "n22-wishlist-storefront-css";
    css.textContent = [
      ".image-wish-btn{position:absolute;top:10px;right:10px;z-index:6;width:34px;height:34px;display:flex;align-items:center;justify-content:center;border:none;background:transparent;padding:0;cursor:pointer;color:var(--rose,#c45b7a);pointer-events:auto;transition:color .2s ease,transform .2s ease}",
      ".image-wish-btn svg{width:22px;height:22px;stroke:currentColor;fill:none;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}",
      ".image-wish-btn:hover{color:var(--berry-deep,#7a2f4a);transform:scale(1.06)}",
      ".image-wish-btn:hover svg{fill:none}",
      ".image-wish-btn.is-saved svg{fill:var(--header-solid-bg,#ffecec);stroke:var(--rose,#c45b7a)}",
      ".n22-storefront-wish-slot,.product-item__link-wrapper,.product__photo,.feature-row__image-wrapper,.collection-list-grid__image-wrapper,.cart__image,.cart-item__image{position:relative}",
      ".n22-storefront-wish-slot>.image-wish-btn,.product-item__link-wrapper .image-wish-btn,.product__photo .image-wish-btn{top:8px;right:8px}"
    ].join("");
    document.head.appendChild(css);
  }

  function currentProductPageMeta() {
    var path = window.location.pathname || "";
    if (!/\/products\//i.test(path)) return null;
    var handleMatch = path.match(/\/products\/([^/?#]+)/i);
    if (!handleMatch) return null;
    var titleEl =
      document.querySelector('.product-single__meta h1, .product__title, h1[itemprop="name"], .template-product h1.h2, .template-product h1') ||
      document.querySelector('meta[property="og:title"]');
    var title = "";
    if (titleEl) {
      title = (titleEl.getAttribute("content") || titleEl.textContent || "").replace(/\s+/g, " ").trim();
    }
    var img = document.querySelector(".product__photo.top-image img, .product__photo img");
    return {
      href: shopProductUrl(handleMatch[1]),
      title: title || handleMatch[1].replace(/-/g, " "),
      image: img ? (img.currentSrc || img.src || img.getAttribute("data-src") || "") : ""
    };
  }

  function prepareStorefrontWishlistSlots(scope) {
    var root = scope || document;

    root.querySelectorAll(".product-item").forEach(function (item) {
      if (item.dataset.n22WishPrepared === "1") return;
      var link = item.querySelector("a.product-item__link[href*='/products/'], a.product-item__link[href*='/collections/']");
      if (!link) return;
      var href = link.getAttribute("href") || "";
      if (!/\/products\//i.test(href) && !/\/collections\//i.test(href)) return;
      var host = item.querySelector(".product-item__link-wrapper") || item;
      host.classList.add("image-slot", "n22-storefront-wish-slot");
      host.setAttribute("data-href", canonicalShopUrl(href));
      var titleEl = item.querySelector(".product-item__title");
      var title = (titleEl && titleEl.textContent.trim()) || link.getAttribute("title") || "";
      if (!title) {
        var img = item.querySelector("img.product-item__image, img");
        title = (img && img.getAttribute("alt")) || "";
      }
      if (title) host.setAttribute("data-wish-title", title);
      item.dataset.n22WishPrepared = "1";
    });

    var productMeta = currentProductPageMeta();
    if (productMeta && productMeta.href) {
      var photos = root.querySelectorAll(".product__photo");
      Array.prototype.forEach.call(photos, function (photo, index) {
        if (photo.dataset.n22WishPrepared === "1") return;
        if (index > 0) return;
        photo.classList.add("image-slot", "n22-storefront-wish-slot");
        photo.setAttribute("data-href", productMeta.href);
        if (productMeta.title) photo.setAttribute("data-wish-title", productMeta.title);
        photo.dataset.n22WishPrepared = "1";
      });
    }

    root.querySelectorAll(".feature-row.power-soft-feature-row, .power-soft-feature-row").forEach(function (row) {
      if (row.dataset.n22WishPrepared === "1") return;
      var link = row.querySelector("a[href*='/products/']");
      if (!link) return;
      var href = link.getAttribute("href") || "";
      if (!/\/products\//i.test(href)) return;
      var host =
        row.querySelector(".feature-row__image-wrapper, .power-soft-feature-row__image-wrapper, .feature-row__item.feature-row__image") ||
        row.querySelector(".grid__item.feature-row__item:not(.feature-row__text)") ||
        link;
      if (host.tagName === "IMG") host = host.parentElement || host;
      host.classList.add("image-slot", "n22-storefront-wish-slot");
      host.setAttribute("data-href", canonicalShopUrl(href));
      var titleNode = row.querySelector("h2, h3, .feature-row__title");
      var title = (titleNode && titleNode.textContent.trim()) || link.textContent.trim() || "";
      if (title) host.setAttribute("data-wish-title", title.replace(/\s+/g, " ").trim());
      row.dataset.n22WishPrepared = "1";
    });

    root.querySelectorAll(".collection-list-grid__item, .collection-grid__item").forEach(function (item) {
      if (item.dataset.n22WishPrepared === "1") return;
      var link = item.querySelector("a.collection-grid__link[href], a[href*='/collections/']");
      if (!link) return;
      var href = link.getAttribute("href") || "";
      if (!/\/collections\//i.test(href) || /\/products\//i.test(href)) return;
      var host =
        item.querySelector(".collection-list-grid__image-wrapper, .collection-list-grid__image, .grid__image") ||
        link;
      host.classList.add("image-slot", "n22-storefront-wish-slot");
      host.setAttribute("data-href", canonicalShopUrl(href));
      var titleEl = item.querySelector(".collection-list-grid__title, .product-item__title, h2, h3");
      if (titleEl) host.setAttribute("data-wish-title", titleEl.textContent.replace(/\s+/g, " ").trim());
      item.dataset.n22WishPrepared = "1";
    });

    root.querySelectorAll(".cart__row, .cart-item, tr.cart__row").forEach(function (row) {
      if (row.dataset.n22WishPrepared === "1") return;
      var link = row.querySelector("a[href*='/products/']");
      if (!link) return;
      var host = row.querySelector(".cart__image, .cart-item__image, td.cart__meta-image, .cart__row-image") || link.parentElement;
      if (!host) return;
      host.classList.add("image-slot", "n22-storefront-wish-slot");
      host.setAttribute("data-href", canonicalShopUrl(link.getAttribute("href") || ""));
      var titleEl = row.querySelector(".cart__product-title, .cart-item__title, a[href*='/products/']");
      if (titleEl) host.setAttribute("data-wish-title", titleEl.textContent.replace(/\s+/g, " ").trim());
      row.dataset.n22WishPrepared = "1";
    });
  }

  function syncHeartButton(btn, id) {
    var saved = readWishlist().some(function (item) { return item.id === id; });
    btn.classList.toggle("is-saved", saved);
    btn.setAttribute("aria-pressed", saved ? "true" : "false");
    btn.setAttribute("aria-label", saved ? "Remove from wishlist" : "Add to wishlist");
  }

  function toggleWishlist(meta) {
    if (!meta || !meta.href) return;
    var id = wishlistId(meta.href);
    var items = readWishlist();
    var index = items.findIndex(function (item) { return item.id === id; });
    if (index >= 0) items.splice(index, 1);
    else {
      items.push({
        id: id,
        title: meta.title || id,
        url: canonicalShopUrl(meta.href),
        image: meta.image || "",
        addedAt: Date.now(),
        checked: false
      });
    }
    writeWishlist(items);
    document.querySelectorAll(".image-wish-btn").forEach(function (btn) {
      var slot = btn.closest(".image-slot, .n22-storefront-wish-slot");
      if (!slot) return;
      syncHeartButton(btn, wishlistId(slot.getAttribute("data-href") || ""));
    });
    // Ask header dropdown to refresh if present
    if (typeof window.refreshWishlistHearts === "function") {
      try { window.refreshWishlistHearts(document); } catch (e) {}
    }
    var trigger = document.getElementById("nav-wishlist-trigger");
    if (trigger) {
      var count = readWishlist().length;
      trigger.classList.toggle("has-wishlist-items", count > 0);
      trigger.setAttribute("aria-label", count ? "Wishlist (" + count + " items)" : "Wishlist");
    }
  }

  function bindFallbackHearts(scope) {
    var root = scope || document;
    root.querySelectorAll(".n22-storefront-wish-slot, .image-slot[data-href]").forEach(function (slot) {
      if (slot.closest(".hero-grid")) return;
      var href = slot.getAttribute("data-href") || "";
      if (!href) return;
      var id = wishlistId(href);
      var btn = slot.querySelector(".image-wish-btn");

      // Header wishlist already owns this slot — only sync visual state
      if (slot.dataset.wishBound === "1") {
        if (btn) syncHeartButton(btn, id);
        slot.dataset.n22BridgeBound = "1";
        return;
      }

      if (slot.dataset.n22BridgeBound === "1") {
        if (btn) syncHeartButton(btn, id);
        return;
      }

      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "image-wish-btn";
        btn.innerHTML = HEART_SVG;
        slot.appendChild(btn);
      }
      syncHeartButton(btn, id);
      if (!btn.dataset.n22BridgeClick) {
        btn.dataset.n22BridgeClick = "1";
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          var img = slot.querySelector("img");
          toggleWishlist({
            href: slot.getAttribute("data-href") || "",
            title: slot.getAttribute("data-wish-title") || "",
            image: img ? (img.currentSrc || img.src || "") : ""
          });
        });
      }
      slot.dataset.n22BridgeBound = "1";
    });
  }

  function refresh() {
    injectWishCss();
    prepareStorefrontWishlistSlots(document);
    if (typeof window.refreshWishlistHearts === "function") {
      try { window.refreshWishlistHearts(document); } catch (e) {}
    }
    // Always ensure storefront hosts have hearts (covers stale header JS)
    bindFallbackHearts(document);
  }

  function boot() {
    var tries = 0;
    function attempt() {
      tries += 1;
      refresh();
      if (tries < 12) window.setTimeout(attempt, 300);
    }
    attempt();

    if (window.MutationObserver) {
      var pending = null;
      var refreshing = false;
      var obs = new MutationObserver(function (mutations) {
        if (refreshing || pending) return;
        var relevant = mutations.some(function (m) {
          if (m.type !== "childList") return false;
          var hit = false;
          m.addedNodes.forEach(function (n) {
            if (!n || n.nodeType !== 1) return;
            if (n.classList && n.classList.contains("image-wish-btn")) return;
            if (
              (n.matches && n.matches(".product-item, .product__photo, .feature-row, .collection-list-grid__item, .cart__row")) ||
              (n.querySelector && n.querySelector(".product-item, .product__photo, .feature-row, .collection-list-grid__item"))
            ) {
              hit = true;
            }
          });
          return hit;
        });
        if (!relevant) return;
        pending = window.setTimeout(function () {
          pending = null;
          refreshing = true;
          try { refresh(); } finally { refreshing = false; }
        }, 300);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
